import React from 'react';
import { Phone, MessageCircle, Calendar } from 'lucide-react';

const WA_NUMBER = '919891550666';
const PHONE_NUMBER = '+919891550666';

const trackEvent = (name) => {
  if (typeof window === 'undefined') return;
  if (window.gtag) window.gtag('event', name);
  if (window.fbq) window.fbq('track', 'Contact', { method: name });
};

const StickyMobileCTA = () => (
  <div data-testid="sticky-mobile-cta" className="fixed bottom-0 left-0 right-0 z-[55] md:hidden bg-black/95 backdrop-blur-xl border-t border-yellow-500/30 grid grid-cols-3">
    <a
      href={`tel:${PHONE_NUMBER}`}
      onClick={() => trackEvent('mobile_call_click')}
      data-testid="sticky-call"
      className="flex flex-col items-center justify-center gap-1 py-3 text-white border-r border-white/10 active:bg-white/5"
    >
      <Phone className="w-5 h-5 text-yellow-300" />
      <span className="text-[10px] font-bold">Call Now</span>
    </a>
    <a
      href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent('Hi, I want counseling for AI courses.')}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent('mobile_whatsapp_click')}
      data-testid="sticky-whatsapp"
      className="flex flex-col items-center justify-center gap-1 py-3 text-white border-r border-white/10 active:bg-white/5"
    >
      <MessageCircle className="w-5 h-5 text-green-400" />
      <span className="text-[10px] font-bold">WhatsApp</span>
    </a>
    <button
      onClick={() => {
        trackEvent('mobile_book_demo_click');
        document.getElementById('enrollment-form')?.scrollIntoView({ behavior: 'smooth' });
      }}
      data-testid="sticky-book-demo"
      className="flex flex-col items-center justify-center gap-1 py-3 text-white active:bg-white/5"
    >
      <Calendar className="w-5 h-5 text-orange-300" />
      <span className="text-[10px] font-bold">Book Demo</span>
    </button>
  </div>
);

export default StickyMobileCTA;
